import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent {
  clientId: string | null = null;
  returnUrl: string | null = null;
  linkRequired = false;
  errorMessage: string | null = null;

  constructor(
    private router: Router,
    private authService: AuthService,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
  ) {
    this.route.queryParams.subscribe((params) => {
      const code = params['code'];
      const state = params['state'];
      const returnUrl = params['returnUrl'];
      this.returnUrl = returnUrl ?? null;

      if (!this.clientId && returnUrl) {
        const url = new URL(returnUrl);
        this.clientId = url.searchParams.get('client_id');
      }

      if (
        this.clientId == null ||
        this.clientId == undefined ||
        this.clientId == ''
      )
        this.clientId = this.authService.getClienteIdLocal();

      if (this.clientId) this.authService.setClienteIdLocal(this.clientId);

      if (code && state) {
        this.spinner.show();
        this.authService.exchangeCodeForToken(code, state).subscribe({
          next: (response) => {
            if (response.linked === true) {
              this.spinner.hide();
              if (response.redirectUrl && this.authService.isTrustedRedirect(response.redirectUrl)) {
                window.location.assign(response.redirectUrl);
              } else {
                this.errorMessage = 'Conta Google vinculada. Volte ao aplicativo e continue a autenticação.';
              }
              return;
            }

            const redirectUrl = response.redirectUrl;
            if (
              redirectUrl &&
              this.authService.isTrustedRedirect(redirectUrl)
            ) {
              this.spinner.hide();
              window.location.assign(redirectUrl);
            } else {
              console.error('URL de redirecionamento não encontrada');
              this.spinner.hide();
            }
          },
          error: (err) => {
            this.spinner.hide();
            if (err?.status === 409 &&
                err?.error?.code === 'google_account_link_required' &&
                typeof err?.error?.returnUrl === 'string' &&
                this.authService.isTrustedRedirect(err.error.returnUrl)) {
              this.returnUrl = err.error.returnUrl;
              this.linkRequired = true;
              this.errorMessage = 'Já existe uma conta DevHubCentral com este e-mail. Entre com a senha dessa conta para vincular o Google com segurança.';
              return;
            }
            this.errorMessage = 'Não foi possível concluir o login com Google. Tente novamente.';
          },
        });
      }
    });
  }

  goTo(path: string) {
    this.router.navigate([path], {
      queryParams: this.returnUrl ? { returnUrl: this.returnUrl } : undefined,
    });
  }

  loginWithGoogle() {
    if (!this.returnUrl) {
      alert(
        'Contexto SSO invalido. Inicie o login pelo sistema que deseja acessar.',
      );
      return;
    }

    window.location.assign(this.authService.getGoogleLoginUrl(this.returnUrl));
  }

  continueWithLocalAccount() {
    if (!this.returnUrl || !this.authService.isTrustedRedirect(this.returnUrl)) return;
    this.router.navigate(['/login'], {
      queryParams: { returnUrl: this.returnUrl, linkGoogle: 'true' },
    });
  }
}
